module.exports = __webpack_public_path__ + "static/media/place-marker.0fc89cde.png";